import React from "react";
import OnRampView from "./view";

const OnRamp = () => {
  return <OnRampView />;
};

export default OnRamp;
